import { GlobalContext } from "../../Global/Base/GlobalContext";
import { ApplicationCache, IAppCache } from "./Cache/IAppCache";
/**Výčet atributů pro cache*/
export enum AppCacheProperties {
    systemOperationRights,
}

/**
 * Aplikační cache s daty uchovávanými v paměti
 */
export class AppMemCache implements IAppCache {
    private __data?: Map<string | number, any>;

    private get _topInstance(): AppMemCache {
        return GlobalContext.getType<typeof ApplicationCache>(ApplicationCache).instance as AppMemCache;
    }

    private get _data(): Map<string | number, any> {
        if (!this._topInstance.__data)
            this._topInstance.__data = new Map<string | number, any>();
        return this._topInstance.__data;
    }

    private set _data(val: Map<string | number, any>) {
        this._topInstance.__data = val;
    }

    /**
     * Získá hodnotu property v cache
     * @param property Unikátní název nebo ID property.
     */
    public getValue<T>(property: string | number): T | undefined {
        return this._data.has(property) ? this._data.get(property) as T : undefined;
    }

    /**
     * Nastaví hodnotu pro property v cache.
     * @param property Unikátní název nebo ID property.
     * @param value Hodnota property.
     */
    public setValue<T>(property: string | number, value: T): void {
        this._data.set(property, value);
    }
}
